console.log('Environment Variables:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  ALL_ENV: process.env
});

export const config = {
  API_URL: process.env.NODE_ENV === 'development' ? '' : process.env.REACT_APP_API_URL,
} as const;